import React from 'react';
import { ScreenRecordingProvider } from './ScreenRecordingContext';
import { SettingsProvider } from './SettingsContext';
export function ScreenRecorderProvider({ children }) {
    return (React.createElement(SettingsProvider, null,
        React.createElement(ScreenRecordingProvider, null, children)));
}
export { useSettingsContext, } from './SettingsContext';
export { useScreenRecordingContext } from './ScreenRecordingContext';
